<template>
  <div id="main-nav">
    <div class="container mx-auto px-4 text-center hidden md:block">
      <div
        class="item group"
        :key="`menu-item${i}`"
        @mouseover.stop="hoverParent(menuItem, ...arguments)"
        v-for="(menuItem, i) in menuItems">
        <a :href="menuItem.link" class="link">{{ menuItem.label }} <action-icons class="inline" icon="caret-down" v-if="menuItem.children.length > 0" /></a>
        <div
          class="absolute z-20 mt-2 bg-blue-500 left-0 hidden group-hover:block w-full pb-8 bg-center bg-cover bg-no-repeat"
          style="height:50vh"
          :style="{backgroundImage: `url('${currentChildBgImage}')`}"
          v-if="menuItem.children.length > 0">
          <div class="relative">
            <div class="py-4 md:w-1/3 lg:w-1/4 absolute" style="background-color:rgba(0,193,222,0.5)" :style="{left: subItemsLeftOffset}">
              <a
                class="subitem"
                :href="child.link"
                :key="`child-${j}`" v-for="(child, j) in menuItem.children"
                @mouseover="updateChildBgImage(child.image)">{{ child.label }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <a href="#" class="link text-blue-500"><action-icons icon="search" class="inline" /></a>
      </div>
    </div>

    <transition name="nav-slide">
      <div class="absolute w-full h-full top-0 left-0 p-4 overflow-y-scroll z-20" style="background-color:rgba(1, 86, 151, 0.96)" v-if="mobileMenuShown">
        <div class="mb-4">
          <button type="button" class="border-blue-300 border rounded text-white" @click="hideMobileNav"><action-icons icon="close" class="inline" /></button>
        </div>

        <div :key="`mobile-menu-item${i}`" v-for="(menuItem, i) in menuItems" class="leading-tight">
          <a :href="menuItem.link" class="mobile-item">{{ menuItem.label }}</a>
          <div class="pl-4 border-l border-blue-300" v-if="menuItem.children.length > 0">
            <a :href="child.link" :key="`mobile-child-${i}-${j}`" v-for="(child, j) in menuItem.children" class="mobile-item">{{ child.label }}</a>
          </div>
        </div>
        <a href="#" class="mobile-item">Buscar</a>

        <div class="flex flex-row items-center my-4 text-white">
          <div class="flex-none mr-2"><img src="/images/icon-phone.svg" class="w-6 lg:w-10 h-6 lg:h-10"></div>
          <div class="flex-1 leading-tight">
            <a href="tel:+50322931553" target="_blank" class="link-basic">+503 2293-1553</a>
            <!-- <br>EE. UU <a href="tel:+13052803241" target="_blank" class="link-basic">+1 (305) 280 3241</a> -->
          </div>
        </div>

        <div class="flex flex-row items-center text-white">
          <div class="flex-none mr-2"><img src="/images/icon-mail.svg" class="w-6 lg:w-10 h-6 lg:h-10"></div>
          <div class="flex-1 leading-tight">
            <a href="mailto:info@gpoatlas.com " target="_blank" class="link-basic">info@gpoatlas.com</a>
          </div>
        </div>

      </div>
    </transition>
  </div>
</template>
<script>
import { globalEventBus } from '@root/_globalEventBus';
export default {
  name: 'main-nav',
  props: {
    menuItems: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      mobileMenuShown: false,
      currentChildBgImage: '/images/nav/our-company.jpg',
      currentChildren: [],
      subItemsLeftOffset: 0,
    }
  },
  methods: {
    showMobileNav() {
      document.body.classList.add('overflow-hidden');
      this.mobileMenuShown = true;
    },
    hideMobileNav () {
      document.body.classList.remove('overflow-hidden');
      this.mobileMenuShown = false;
    },
    hoverParent(menuItem, event) {
      this.subItemsLeftOffset = `${event.currentTarget.offsetLeft}px`;
      if (menuItem.children.length > 0) {
        this.currentChildBgImage = menuItem.children[0].image;
      }
    },
    updateChildBgImage(slug) {
      event.stopPropagation();
      this.currentChildBgImage = slug;
    }
  },
  mounted() {
    globalEventBus.$on('mobileMenuClicked', method => {
      this.showMobileNav();
    });
  },
}
</script>